import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, Redirect, Link } from 'react-router-dom'
import { Input, Button } from 'sfy-react'
import { postRequestAsync } from '../../../common/genericApi'
import { checkValues } from '../../../utils/regex'
import { setLoader } from '../../../store/common'
import ViewIcon from '../../../assets/images/eye.svg'
import HideIcon from '../../../assets/images/hide.svg'

const useQuery = () => {
  const { search } = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}

const ChangePassword = () => {
  const dispatch = useDispatch()

  const [isSubmitted, setIsSubmitted] = useState(false)
  const [formSuccessMessage, setFormSuccess] = useState('')
  const [formError, setFormError] = useState('')
  const query = useQuery()
  const accessToken = query.get('access_token')
  const region = query.get('region')
  const [fields, setFields] = useState({
    password: { label: 'Password', placeholder: 'Enter your new password', value: '', error: '', showPassword: false },
    confirmPassword: { label: 'Confirm Password', placeholder: 'Confirm your new password', value: '', error: '', showPassword: false },
  })

  const passwordInput = fields['password']
  const confirmPasswordInput = fields['confirmPassword']

  const IMAGES = {
    SHOW_PASSSWORD: HideIcon,
    HIDE_PASSWORD: ViewIcon,
  }

  const handleChange = (key, value) => {
    setIsSubmitted(false)
    setFormSuccess(false)
    setFields((prevState) => ({
      ...prevState,
      [key]: { ...prevState[key], value: value.trim() },
    }))
  }

  const toggleShowPassword = (key) => {
    setFields((prevState) => ({
      ...prevState,
      [key]: { ...prevState[key], showPassword: !prevState[key].showPassword },
    }))
  }

  useEffect(() => {
    let { isValid, isEmpty, error } = checkValues({ password: passwordInput.value })
    if (!isSubmitted) return

    if (isEmpty) {
      setFields((prevState) => ({
        ...prevState,
        password: { ...prevState['password'], error: 'This is a required field' },
      }))
    } else if (isValid) {
      setFields((prevState) => ({
        ...prevState,
        password: { ...prevState['password'], error: '' },
      }))
      setFormError('')
    } else if (error) {
      setFields((prevState) => ({
        ...prevState,
        password: { ...prevState['password'], error: error },
      }))
    }
  }, [isSubmitted, passwordInput.value])

  useEffect(() => {
    const confirmPassword = confirmPasswordInput.value
    const newPassword = passwordInput.value

    if (confirmPassword !== newPassword && newPassword && isSubmitted) {
      setFormError('Passwords do not match. Please check the password you have entered.')
    } else {
      setFormError('')
    }
  }, [isSubmitted, confirmPasswordInput.value, passwordInput.value])

  useEffect(() => {
    localStorage.setItem('selectedRegion', region)
  }, [region])

  const handleOnSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitted(true)
    const newPassword = passwordInput
    const confirmPassword = confirmPasswordInput

    if (
      !newPassword.error &&
      newPassword.value &&
      !confirmPassword.error &&
      confirmPassword.value &&
      !formError &&
      newPassword.value === confirmPassword.value
    ) {
      try {
        dispatch(setLoader(true))
        let response = await postRequestAsync('/user/resetPassword', {
          password: newPassword.value,
          accessToken: accessToken,
        })
        if (response.success) setFormSuccess(response.msg)
        dispatch(setLoader(false))
      } catch (e) {
        console.log(e)
        setFormError(e.msg || 'Could not reset your password.')
        dispatch(setLoader(false))
      }
    }
  }

  if (!accessToken) return <Redirect exact to='/login' />
  return (
    <form onSubmit={handleOnSubmit}>
      <div className='reset-password-title'>
        New Password
      </div>
      {fields &&
        Object.keys(fields).map((eachField, index) => {
          const { value, error, placeholder, showPassword, label } = fields[eachField]
          return (
            <Input
              label={label}
              key={index}
              placeholder={placeholder}
              message={{ value: error }}
              className={{
                formControl: index === 0 ? `mb20` : '',
                inputContainer: 'password-field',
                message: error ? 'error' : '',
                label: 'label',
              }}
              value={value}
              handleOnChange={(e) => handleChange(eachField, e.target.value)}
              name={eachField}
              otherProps={{ type: showPassword ? 'text' : 'password' }}
            >
              {index === 0 && (
                <span className='password-control' onClick={() => toggleShowPassword(eachField)}>
                  <img src={showPassword ? IMAGES.HIDE_PASSWORD : IMAGES.SHOW_PASSSWORD} alt='password' />
                </span>
              )}
            </Input>
          )
        })}

      {formSuccessMessage && isSubmitted && (
        <div className='d-flex'>
          <div className='success color-theme mt10'>{formSuccessMessage}</div>
        </div>
      )}

      {isSubmitted && formError && (
        <div className='d-flex'>
          <div className='error mt10'>{formError}</div>
        </div>
      )}

      <Button
        type='submit'
        text='Change Password'
        classes='button-primary botton-submit mt30'
        isDisabled={formSuccessMessage && isSubmitted}
      />

      {formSuccessMessage && isSubmitted && (
        <div className='d-flex justify-center'>
          <Link to='/login' title='Login' className='mt10 link'>
            Back to login
          </Link>
        </div>
      )}
    </form>
  )
}

export default ChangePassword
